module.exports = __webpack_public_path__ + "img/monitoringdescription2.1d35f56c.png";